import React from 'react';
import GlobalSearch from '../Common/GlobalSearch';
import KpiSearch from '../Common/KpiSearch';

export default function PrimarySearch(props) {
	const { module = 'global' } = props;
	return (
		<div className='primary-search-field'>
			{module === 'kpi' ? (
				<KpiSearch {...props} module={module} fetchCycleUsers={true} customId={'global-src'} />
			) : (
				<GlobalSearch {...props} module={module} fetchCycleUsers={true} customId={'global-src'} />
			)}
		</div>
	);
}
